import React, { useEffect, useState, useRef, useCallback, useContext } from "react";
import {
	TextField,
	CircularProgress,
	Switch,
	FormControlLabel,
	Select,
	MenuItem,
	Tabs,
	Tab,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
} from "@material-ui/core";
import { NumericFormat } from "react-number-format";
import styled from "styled-components";
import {
	BookingContentName,
	BookingContentWrap,
	ButtonUserWrap,
	MyBookingWrapper,
	AdminTransactionAddButtton,
} from "../MyBooking/styled/DesStyled";
import {
	SystemConfig,
	getSystemConfig,
	saveSystemConfig,
	getHotlineAffectedCount,
	PaymentCycleConfig,
	getPaymentCycleConfig,
	savePaymentCycleConfig,
	runFinishOrderJob,
	previewFinishOrderJob,
} from "../../../services/SystemConfigService";
import { AuthenticationContext } from "../../controls/auth/AuthenticationWrap";
import { UserRole } from "../../../models/User";
import PermissionGate from "../../controls/auth/PermissionGate";

/* ──────── styled components ──────── */
const PageCard = styled.div`
	max-width: 920px;
	margin: 0 auto;
	padding: 32px 36px 40px;
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06), 0 4px 16px rgba(0, 0, 0, 0.04);
`;

const ConfigTabsBar = styled.div`
	position: sticky;
	top: 0;
	z-index: 4;
	margin: 0 -36px 4px;
	padding: 0 0 0;
	background: #fff;
	border-bottom: 1px solid #e5e7eb;
	box-shadow: 0 1px 0 rgba(0, 0, 0, 0.03);

	& .MuiTab-root {
		font-size: 13px;
		font-weight: 600;
		min-width: 0;
		text-transform: none;
		letter-spacing: 0.01em;
		padding: 10px 14px;
	}
	& .MuiTab-textColorPrimary {
		color: #6b7280;
	}
	& .MuiTab-textColorPrimary.Mui-selected {
		color: #1d4ed8;
	}
	& .MuiTabs-indicator {
		background-color: #2563eb;
	}
`;

const StickySaveRow = styled.div`
	position: sticky;
	bottom: 0;
	z-index: 4;
	margin: 24px -36px -24px;
	padding: 12px 36px 4px;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.72) 0%, #fff 24%);
	backdrop-filter: blur(4px);
	border-top: 1px solid #e5e7eb;
	display: flex;
	justify-content: flex-end;
`;

const SummaryToggle = styled.button`
	appearance: none;
	border: none;
	background: transparent;
	color: #2563eb;
	font-size: 12px;
	font-weight: 600;
	cursor: pointer;
	padding: 2px 0;
	margin: 0 0 8px;
	&:hover {
		text-decoration: underline;
	}
`;

const PageTitle = styled.h1`
	font-size: 22px;
	font-weight: 700;
	color: #1a1a2e;
	margin: 0 0 4px;
`;

const PageSubtitle = styled.p`
	font-size: 13px;
	color: #6b7280;
	margin: 0 0 24px;
`;

const SummaryBox = styled.div`
	background: linear-gradient(135deg, #f0f9ff 0%, #f5f3ff 100%);
	border: 1px solid #dbeafe;
	border-radius: 10px;
	padding: 16px 20px;
	margin-bottom: 28px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px 32px;
`;

const SummaryItem = styled.div`
	font-size: 13px;
	color: #374151;
	display: flex;
	align-items: center;
	gap: 8px;
	& b {
		color: #1e40af;
	}
`;

const SummaryIcon = styled.span`
	width: 28px;
	height: 28px;
	border-radius: 8px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
	flex-shrink: 0;
`;

const SectionTitle = styled.div`
	font-size: 11px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	color: #9ca3af;
	margin-bottom: 12px;
	padding-bottom: 6px;
	border-bottom: 1px solid #f3f4f6;
`;

const FieldCard = styled.div`
	background: #fafafa;
	border: 1px solid #f0f0f0;
	border-radius: 8px;
	padding: 14px 16px;
	transition: border-color 0.15s;
	&:hover {
		border-color: #d1d5db;
	}
`;

const FieldLabel = styled.div`
	font-weight: 600;
	font-size: 14px;
	color: #111827;
	margin-bottom: 2px;
	display: flex;
	align-items: center;
	gap: 6px;
`;

const FieldDesc = styled.div`
	color: #6b7280;
	font-size: 12px;
	margin-bottom: 8px;
	line-height: 1.4;
`;

const InfoButton = styled.button`
	width: 18px;
	height: 18px;
	border-radius: 50%;
	border: 1.5px solid #9ca3af;
	background: #fff;
	color: #6b7280;
	font-size: 11px;
	font-weight: 700;
	line-height: 1;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	flexshrink: 0;
	transition: all 0.15s;
	&:hover {
		border-color: #2563eb;
		color: #2563eb;
		background: #eff6ff;
	}
`;

const TooltipBubble = styled.div`
	position: absolute;
	top: calc(100% + 6px);
	left: 0;
	z-index: 50;
	background: #1f2937;
	color: #f9fafb;
	font-size: 12px;
	line-height: 1.5;
	padding: 10px 14px;
	border-radius: 8px;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
	max-width: 360px;
	min-width: 220px;
	pointer-events: auto;
	animation: fadeIn 0.12s ease-out;
	&::before {
		content: "";
		position: absolute;
		top: -5px;
		left: 14px;
		width: 10px;
		height: 10px;
		background: #1f2937;
		transform: rotate(45deg);
		border-radius: 2px;
	}
	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(-4px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

function InfoTooltip({ text }: { text: string }) {
	const [open, setOpen] = useState(false);
	const ref = useRef<HTMLDivElement>(null);

	const handleClickOutside = useCallback((e: MouseEvent) => {
		if (ref.current && !ref.current.contains(e.target as Node)) {
			setOpen(false);
		}
	}, []);

	useEffect(() => {
		if (open) {
			document.addEventListener("mousedown", handleClickOutside);
			return () => document.removeEventListener("mousedown", handleClickOutside);
		}
	}, [open, handleClickOutside]);

	return (
		<div
			ref={ref}
			style={{ position: "relative", display: "inline-flex" }}>
			<InfoButton
				type="button"
				onClick={() => setOpen((v) => !v)}
				title="Xem mô tả">
				!
			</InfoButton>
			{open && <TooltipBubble>{text}</TooltipBubble>}
		</div>
	);
}

function toDatetimeLocalValue(iso: string): string {
	if (!iso || typeof iso !== "string") return "";
	const d = new Date(iso.trim());
	if (Number.isNaN(d.getTime())) return "";
	const pad = (n: number) => String(n).padStart(2, "0");
	return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(
		d.getMinutes()
	)}`;
}

function fromDatetimeLocalValue(local: string): string {
	if (!local || typeof local !== "string") return "";
	const d = new Date(local);
	if (Number.isNaN(d.getTime())) return "";
	return d.toISOString();
}

const SaveButton = styled.button<{ disabled?: boolean }>`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	padding: 10px 28px;
	border: none;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 600;
	color: #fff;
	background: ${(p) => (p.disabled ? "#9ca3af" : "linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)")};
	cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
	transition: opacity 0.15s, transform 0.1s;
	box-shadow: 0 2px 8px rgba(37, 99, 235, 0.18);
	&:hover:not(:disabled) {
		opacity: 0.92;
		transform: translateY(-1px);
	}
	&:active:not(:disabled) {
		transform: translateY(0);
	}
`;

type FieldDef = {
	key: keyof SystemConfig;
	label: string;
	description: string;
	type: "number" | "text" | "select" | "boolean" | "date";
	step?: string;
	min?: number;
	max?: number;
	options?: { value: string; label: string }[];
};

const FIELDS: FieldDef[] = [
	{
		key: "holdingPeriodDays",
		label: "Holding Period (ngày)",
		description: "Số ngày giữ sau checkout trước khi booking chuyển sang Available. Theo tài liệu: 11 ngày.",
		type: "number",
		min: 1,
		max: 365,
	},
	{
		key: "defaultSystemRate",
		label: "Default System Rate (USD)",
		description:
			"Mức Station Commission mặc định khi quốc gia chưa được cấu hình trong Country Rates. (Mặc định: 2.25 USD)",
		type: "number",
		step: "0.01",
		min: 0.01,
	},
	{
		key: "minimumPayoutUsd",
		label: "Minimum Payout (USD)",
		description: "Số tiền tối thiểu (USD) để station được phép Withdraw. Đặt 0 để không giới hạn.",
		type: "number",
		step: "0.01",
		min: 0,
	},
	{
		key: "maxPayoutUsd",
		label: "Max Payout (USD)",
		description:
			"Ngưỡng available quy đổi USD để hệ thống tự động tạo payment request và gửi email Mẫu 1. Đặt 0 để tắt auto.",
		type: "number",
		step: "0.01",
		min: 0,
	},
	{
		key: "startDate",
		label: "Start Date",
		description: "Ngày bắt đầu tính công nợ (chỉ xét booking có timeOut >= ngày này). Định dạng: YYYY-MM-DD.",
		type: "text",
	},
	{
		key: "systemTimezone",
		label: "System Timezone",
		description:
			"Múi giờ chuẩn của hệ thống cho các nghiệp vụ tài chính (holding period, payment, debt, báo cáo). Mặc định: Asia/Ho_Chi_Minh (UTC+7).",
		type: "select",
		options: [
			{ value: "Asia/Ho_Chi_Minh", label: "Asia/Ho_Chi_Minh (UTC+7) — Giờ Việt Nam" },
			{ value: "Asia/Bangkok", label: "Asia/Bangkok (UTC+7)" },
			{ value: "Asia/Singapore", label: "Asia/Singapore (UTC+8)" },
			{ value: "Asia/Tokyo", label: "Asia/Tokyo (UTC+9)" },
			{ value: "Asia/Seoul", label: "Asia/Seoul (UTC+9)" },
			{ value: "UTC", label: "UTC (UTC+0)" },
		],
	},
	{
		key: "bookingValidateByStationTz",
		label: "Kiểm tra ngày đặt theo timezone Station",
		description:
			"Bật: Drop-off date phải >= ngày hiện tại theo timezone của station. Tắt: kiểm tra theo giờ hệ thống.",
		type: "boolean",
	},
	{
		key: "showEsimServiceButton",
		label: "Hiển thị nút eSIM Service",
		description: "Cho phép khách nhìn thấy và bấm CTA eSIM Service ở trang success sau thanh toán.",
		type: "boolean",
	},
	{
		key: "showAirportServiceButton",
		label: "Hiển thị nút Airport Service",
		description: "Cho phép khách nhìn thấy và bấm CTA Airport Service ở trang success sau thanh toán.",
		type: "boolean",
	},
	{
		key: "homepageMaintenanceEnabled",
		label: "Bật maintenance cho Homepage",
		description:
			"Khi bật, trang chủ public (`/`) sẽ hiển thị giao diện maintenance thay vì nội dung homepage thông thường.",
		type: "boolean",
	},
	{
		key: "disableStationNotifications",
		label: "Ẩn Notifications trên Station portal",
		description:
			"Bật (ON) = ẩn hoàn toàn Notifications (sidebar, mobile). Tắt (OFF) = station thấy Notifications. Sau khi Lưu, mở lại tab Station hoặc F5 để đồng bộ (app tự refetch khi chuyển tab về).",
		type: "boolean",
	},
	{
		key: "orderVerificationPinEnabled",
		label: "Xác minh khách bằng PIN 4 số (Station)",
		description:
			"Bật: sau thanh toán hệ thống có thể gửi PIN; station nhập PIN để xác nhận khách đến; hết hạn có thể chuyển No-Show theo cấu hình. Tắt: ẩn luồng verify trên station và không áp dụng nghiệp vụ PIN. Lưu xong nên F5 trang station để đồng bộ.",
		type: "boolean",
	},
	{
		key: "orderVerificationEffectiveFrom",
		label: "Ngày bắt đầu áp dụng PIN theo ngày tạo đơn",
		description:
			"Chọn ngày theo lịch (lưu dạng YYYY-MM-DD). Chỉ đơn có thời điểm tạo (CreatedAt) từ 0:00 ngày này (theo múi giờ hệ thống) mới nằm trong luồng PIN. Xóa chọn/để trống = mọi đơn (khi đã bật PIN ở trên). So với ngày đặt hàng, không dùng drop-off (timeIn) hay checkout.",
		type: "date",
	},
	{
		key: "orderVerificationPinExpiryCalendarDays",
		label: "PIN hết hạn theo ngày lịch (N ngày sau ngày drop-off)",
		description:
			"Mặc định 3: PIN hết hạn đúng 00:00 (theo múi giờ hệ thống) vào ngày = ngày drop-off trên lịch + N. Ví dụ N=1 và drop-off 23:00 ngày 10/4 thì hết hạn 00:00 ngày 11/4. Đặt 0 để dùng chế độ cũ: hết hạn sau X phút kể từ timeIn (ô bên dưới). Khi hết hạn (cron hoặc verify), hệ thống xóa PIN khỏi đơn.",
		type: "number",
		min: 0,
		max: 31,
	},
	{
		key: "orderVerificationPinExpiryMinutes",
		label: "PIN hết hạn sau (phút, từ giờ drop-off) — chỉ khi N = 0",
		description:
			"Chỉ áp dụng khi “ngày lịch” = 0. Cộng vào timeIn. Nếu drop-off còn ở tương lai, PIN chỉ hết hạn sau timeIn + X phút. Cron quét No-Show theo lịch; API verify vẫn kiểm tra realtime.",
		type: "number",
		min: 1,
		max: 8760 * 60,
	},
	{
		key: "verificationExpireJobEnabled",
		label: "Job tự động: PIN hết hạn → No-Show",
		description:
			"Bật: theo lịch cron bên dưới, hệ thống quét đơn đã có PIN, chưa verify, quá hạn và chuyển No-Show. Ngoài ra mỗi lần station tải danh sách đơn, API cũng chạy quét một lần (không phải chờ cron) để UI khớp cấu hình phút ngắn. Có thể bật/tắt không cần restart (mỗi lần chạy job đọc lại cấu hình).",
		type: "boolean",
	},
	{
		key: "verificationExpireCron",
		label: "Cron hết hạn PIN (Asia/Ho_Chi_Minh)",
		description:
			"Biểu thức cron 5 trường. Đổi lịch cần restart backend để nạp biểu thức mới; bật/tắt job thì không cần.",
		type: "text",
	},
	{
		key: "summaryFinishOrderJobEnabled",
		label: "Job tự động: Confirmed → Finished sau N ngày",
		description:
			"Bật: job định kỳ (mặc định 1h sáng HCM, biến môi trường SUMMARY_FINISH_ORDER_TIMER — đổi cần restart) quét đơn Paid/Reserved và chuyển Finished khi đủ số ngày lịch sau ngày checkout (timeOut), N lấy từ ô bên dưới. Tắt: không quét. Cờ lưu trong DB; nếu chưa từng lưu, backend vẫn đọc ENABLE_SUMMARY_FINISH_ORDER khi biến đó được set.",
		type: "boolean",
	},
	{
		key: "orderAutoFinishDaysAfterVerify",
		label: "N ngày lịch sau ngày kết thúc booking (timeOut)",
		description:
			"Đếm theo ngày dương lịch (múi giờ station nếu có timeZoneId, không thì múi giờ hệ thống). Ví dụ N=11 và ngày checkout 07/04 thì từ 18/04 job có thể chuyển Finished. Khác Holding Period (thanh toán đối tác).",
		type: "number",
		min: 1,
		max: 365,
	},
];

export default function SystemConfigPage() {
	const authCtx = useContext(AuthenticationContext);
	const isAuthReady = !!authCtx?.isFinishedValidate;
	const isAuthenticated = !!authCtx?.isValidated;
	const isAdmin = authCtx?.userInfo?.role === UserRole.Admin;

	const [loading, setLoading] = useState(false);
	const [saving, setSaving] = useState(false);
	const [runningFinishJob, setRunningFinishJob] = useState(false);
	const [previewingFinishJob, setPreviewingFinishJob] = useState(false);
	const [finishJobPreview, setFinishJobPreview] = useState<null | {
		total: number;
		orders: Array<{ id: number; status: number; timeOut: string; verifiedAt: string | null }>;
	}>(null);
	const [config, setConfig] = useState<SystemConfig>({
		holdingPeriodDays: 11,
		defaultSystemRate: 2.25,
		minimumPayoutUsd: 0,
		maxPayoutUsd: 0,
		startDate: "2026-01-01",
		systemTimezone: "Asia/Ho_Chi_Minh",
		bookingValidateByStationTz: true,
		showEsimServiceButton: true,
		showAirportServiceButton: true,
		homepageMaintenanceEnabled: false,
		disableStationNotifications: false,
		orderVerificationPinEnabled: false,
		orderVerificationPinExpiryCalendarDays: 3,
		orderVerificationPinExpiryMinutes: 24 * 60,
		orderVerificationEffectiveFrom: "",
		verificationExpireJobEnabled: false,
		verificationExpireCron: "0 */2 * * *",
		summaryFinishOrderJobEnabled: true,
		orderAutoFinishDaysAfterVerify: 11,
		stationPortalBroadcastEnabled: false,
		stationPortalBroadcastTitle: "",
		stationPortalBroadcastBody: "",
		stationPortalBroadcastStartsAt: "",
		stationPortalBroadcastEndsAt: "",
		stationPortalBroadcastDisplayMode: "popup",
		stationPortalBroadcastPartnerCreatedOnOrBefore: "",
		stationPortalLegalAgreementExemptPartnerCreatedOnOrAfter: "",
		stationPortalOnboardingRequiredFromDate: "",
		stationSupportPhone: "0866888431",
		defaultMainHotline: "",
		defaultGeneralHotline: "",
		defaultStationSupportHotline: "0866888431",
		landingHotline: "+84 866 888 431",
	});
	const [updatedAt, setUpdatedAt] = useState<string | undefined>();
	const [cycleConfig, setCycleConfig] = useState<PaymentCycleConfig>({
		cycle1EndDay: 15,
		cycle2EmailDay: 1,
		cycle1PayStart: 1,
		cycle1PayEnd: 5,
		cycle2PayStart: 16,
		cycle2PayEnd: 20,
	});
	/** 0: finance + chu kỳ TT; 1: múi giờ + CTA + homepage; 2: trạm + broadcast + chạy job */
	const [activeTab, setActiveTab] = useState(0);
	const [summaryOpen, setSummaryOpen] = useState(false);

	/** Baseline hotline values captured on load — used to detect changes before save */
	const hotlineBaseline = useRef({
		defaultMainHotline: "",
		defaultGeneralHotline: "",
		defaultStationSupportHotline: "",
	});

	/** Confirm dialog state */
	const [hotlineConfirm, setHotlineConfirm] = useState<{ open: boolean; affectedCount: number; inputValue: string }>({
		open: false,
		affectedCount: 0,
		inputValue: "",
	});

	useEffect(() => {
		setActiveTab((t) => (t > 2 ? 0 : t));
	}, []);

	useEffect(() => {
		let mounted = true;

		if (!isAuthReady) {
			setLoading(true);
			return () => {
				mounted = false;
			};
		}

		if (!isAuthenticated || !isAdmin) {
			setLoading(false);
			return () => {
				mounted = false;
			};
		}

		(async () => {
			try {
				setLoading(true);
				const [sysData, cycleData] = await Promise.all([getSystemConfig(), getPaymentCycleConfig()]);
				if (!mounted) return;
				const { updatedAt: ua, ...rest } = sysData as any;
				setConfig(rest);
				setUpdatedAt(ua);
				// Capture hotline baseline so we can detect changes on save
				hotlineBaseline.current = {
					defaultMainHotline: rest.defaultMainHotline ?? "",
					defaultGeneralHotline: rest.defaultGeneralHotline ?? "",
					defaultStationSupportHotline: rest.defaultStationSupportHotline ?? "",
				};
				const { updatedAt: _cu, ...cycleRest } = cycleData as any;
				setCycleConfig(cycleRest);
			} catch (err: any) {
				alert(`Không tải được cấu hình: ${err?.response?.data?.message || err?.message || "Vui lòng thử lại"}`);
			} finally {
				setLoading(false);
			}
		})();
		return () => {
			mounted = false;
		};
	}, [isAuthReady, isAuthenticated, isAdmin]);

	const onChangeNumber = (key: keyof SystemConfig, value: string) => {
		const n = parseFloat(value);
		setConfig((prev) => ({ ...prev, [key]: Number.isFinite(n) ? n : 0 }));
	};

	const onChangeText = (key: keyof SystemConfig, value: string) => {
		setConfig((prev) => ({ ...prev, [key]: value }));
	};

	const onChangeBool = (key: keyof SystemConfig) => {
		setConfig((prev) => ({ ...prev, [key]: !(prev as any)[key] }));
	};

	const onPreviewFinishJob = async () => {
		if (previewingFinishJob) return;
		try {
			setPreviewingFinishJob(true);
			setFinishJobPreview(null);
			const result = await previewFinishOrderJob();
			setFinishJobPreview(result);
		} catch (err: any) {
			alert(`❌ Lỗi preview: ${err?.response?.data?.message || err?.message || "Vui lòng thử lại"}`);
		} finally {
			setPreviewingFinishJob(false);
		}
	};

	const onRunFinishJob = async () => {
		if (runningFinishJob) return;
		try {
			setRunningFinishJob(true);
			setFinishJobPreview(null);
			const result = await runFinishOrderJob();
			alert(
				`✅ ${result.message}\nBắt đầu: ${new Date(result.startedAt).toLocaleString(
					"vi-VN"
				)}\nKết thúc: ${new Date(result.finishedAt).toLocaleString("vi-VN")}`
			);
		} catch (err: any) {
			alert(`❌ Lỗi khi chạy job: ${err?.response?.data?.message || err?.message || "Vui lòng thử lại"}`);
		} finally {
			setRunningFinishJob(false);
		}
	};

	const onSave = async () => {
		// Detect if any of the 3 hotline defaults changed vs baseline
		const baseline = hotlineBaseline.current;
		const hotlineChanged =
			(config.defaultMainHotline ?? "") !== baseline.defaultMainHotline ||
			(config.defaultGeneralHotline ?? "") !== baseline.defaultGeneralHotline ||
			(config.defaultStationSupportHotline ?? "") !== baseline.defaultStationSupportHotline;

		if (hotlineChanged) {
			try {
				const count = await getHotlineAffectedCount();
				setHotlineConfirm({ open: true, affectedCount: count, inputValue: "" });
			} catch (err: any) {
				alert(
					`Không lấy được số station bị ảnh hưởng: ${
						err?.response?.data?.message || err?.message || "Vui lòng thử lại"
					}`
				);
			}
			return;
		}

		await doSave();
	};

	const doSave = async () => {
		try {
			setSaving(true);
			await Promise.all([saveSystemConfig(config), savePaymentCycleConfig(cycleConfig)]);
			setUpdatedAt(new Date().toISOString());
			// Refresh baseline so next save không re-trigger confirm
			hotlineBaseline.current = {
				defaultMainHotline: config.defaultMainHotline ?? "",
				defaultGeneralHotline: config.defaultGeneralHotline ?? "",
				defaultStationSupportHotline: config.defaultStationSupportHotline ?? "",
			};
			setHotlineConfirm({ open: false, affectedCount: 0, inputValue: "" });
			alert("Đã lưu cấu hình hệ thống thành công.");
		} catch (err: any) {
			alert(`Lưu thất bại: ${err?.response?.data?.message || err?.message || "Vui lòng thử lại"}`);
		} finally {
			setSaving(false);
		}
	};

	return (
		<MyBookingWrapper>
			<PageCard>
				<PageTitle>⚙️ Cấu hình Hệ thống</PageTitle>
				<PageSubtitle>
					Chia theo tab để tìm nhanh; <strong>một lần Lưu</strong> ghi tất cả cấu hình (gồm chu kỳ thanh
					toán).
					{updatedAt && (
						<>
							{" · "}Cập nhật lần cuối: <b>{new Date(updatedAt).toLocaleString("vi-VN")}</b>
						</>
					)}
				</PageSubtitle>

				{loading ? (
					<div style={{ textAlign: "center", padding: 48 }}>
						<CircularProgress size={36} />
					</div>
				) : !isAuthenticated || !isAdmin ? (
					<div
						style={{
							background: "#fff7ed",
							border: "1px solid #fed7aa",
							borderRadius: 8,
							padding: "12px 16px",
							color: "#9a3412",
							fontSize: 14,
							marginBottom: 12,
						}}>
						Trang này chỉ dành cho tài khoản admin. Vui lòng đăng nhập admin để tiếp tục.
					</div>
				) : (
					<>
						<SummaryToggle
							type="button"
							onClick={() => setSummaryOpen((v) => !v)}
							aria-expanded={summaryOpen}>
							{summaryOpen ? "Ẩn tóm tắt nhanh" : "Hiện tóm tắt nhanh — trạng thái chính"}
						</SummaryToggle>
						{summaryOpen && (
							<SummaryBox>
								<SummaryItem>
									<SummaryIcon style={{ background: "#dbeafe" }}>📅</SummaryIcon>
									Holding: <b>{config.holdingPeriodDays} ngày</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon style={{ background: "#fef3c7" }}>💰</SummaryIcon>
									Rate: <b>{config.defaultSystemRate} USD</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon style={{ background: "#d1fae5" }}>💵</SummaryIcon>
									Min Payout: <b>{config.minimumPayoutUsd} USD</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon style={{ background: "#fee2e2" }}>MP</SummaryIcon>
									Max Payout: <b>{config.maxPayoutUsd} USD</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon style={{ background: "#ede9fe" }}>🗓️</SummaryIcon>
									Start: <b>{config.startDate}</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon style={{ background: "#e0f2fe" }}>🌐</SummaryIcon>
									Timezone: <b>{config.systemTimezone}</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon
										style={{
											background: config.bookingValidateByStationTz ? "#d1fae5" : "#fee2e2",
										}}>
										{config.bookingValidateByStationTz ? "✅" : "❌"}
									</SummaryIcon>
									Booking TZ Station: <b>{config.bookingValidateByStationTz ? "Bật" : "Tắt"}</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon
										style={{ background: config.showEsimServiceButton ? "#d1fae5" : "#fee2e2" }}>
										{config.showEsimServiceButton ? "📶" : "🚫"}
									</SummaryIcon>
									eSIM CTA: <b>{config.showEsimServiceButton ? "Hiện" : "Ẩn"}</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon
										style={{ background: config.showAirportServiceButton ? "#d1fae5" : "#fee2e2" }}>
										{config.showAirportServiceButton ? "✈️" : "🚫"}
									</SummaryIcon>
									Airport CTA: <b>{config.showAirportServiceButton ? "Hiện" : "Ẩn"}</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon
										style={{
											background: config.homepageMaintenanceEnabled ? "#fee2e2" : "#d1fae5",
										}}>
										{config.homepageMaintenanceEnabled ? "🛠️" : "✅"}
									</SummaryIcon>
									Homepage maintenance: <b>{config.homepageMaintenanceEnabled ? "Bật" : "Tắt"}</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon
										style={{
											background: config.disableStationNotifications ? "#fee2e2" : "#d1fae5",
										}}>
										{config.disableStationNotifications ? "🔕" : "🔔"}
									</SummaryIcon>
									Station Notifications:{" "}
									<b>{config.disableStationNotifications ? "Đang ẩn" : "Đang hiện"}</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon
										style={{
											background: config.orderVerificationPinEnabled ? "#dbeafe" : "#f3f4f6",
										}}>
										{config.orderVerificationPinEnabled ? "🔢" : "—"}
									</SummaryIcon>
									PIN xác minh station: <b>{config.orderVerificationPinEnabled ? "Bật" : "Tắt"}</b>
								</SummaryItem>
								<SummaryItem>
									<SummaryIcon
										style={{
											background: config.stationPortalBroadcastEnabled ? "#fef3c7" : "#f3f4f6",
										}}>
										{config.stationPortalBroadcastEnabled ? "📣" : "—"}
									</SummaryIcon>
									Broadcast Station Portal:{" "}
									<b>{config.stationPortalBroadcastEnabled ? "Bật" : "Tắt"}</b>
								</SummaryItem>
							</SummaryBox>
						)}

						<ConfigTabsBar>
							<Tabs
								value={activeTab > 2 ? 0 : activeTab}
								onChange={(_e, v) => setActiveTab(v)}
								indicatorColor="primary"
								textColor="primary"
								variant="scrollable"
								scrollButtons="auto"
								aria-label="Nhóm cấu hình hệ thống">
								<Tab label="Tài chính & công nợ" />
								<Tab label="Múi giờ & khách hàng" />
								<Tab label="Trạm, portal & tự động" />
							</Tabs>
						</ConfigTabsBar>

						{/* Tab: Tài chính (phần 1) */}
						{activeTab === 0 && (
							<>
								{/* ── Financial Settings ── */}
								<SectionTitle>Tài chính &amp; Công nợ</SectionTitle>
								<div style={{ display: "grid", gap: 14, marginBottom: 28 }}>
									{FIELDS.filter((f) =>
										[
											"holdingPeriodDays",
											"defaultSystemRate",
											"minimumPayoutUsd",
											"maxPayoutUsd",
											"startDate",
										].includes(f.key as string)
									).map(({ key, label, description, type, step, min, max }) => (
										<FieldCard key={key}>
											<FieldLabel>
												{label}
												<InfoTooltip text={description} />
											</FieldLabel>
											{type === "number" ? (
												<NumericFormat
													value={(config as any)[key] ?? ""}
													onValueChange={(values) => {
														let finalValue = values.value;
														// Allow empty string to just be an empty state
														if (finalValue === "") {
															setConfig((prev) => ({ ...prev, [key]: 0 }));
														} else {
															onChangeNumber(key, finalValue);
														}
													}}
													thousandSeparator=","
													decimalSeparator="."
													allowNegative={false}
													decimalScale={step === "0.01" ? 2 : 0}
													customInput={TextField}
													variant="outlined"
													size="small"
													style={{ width: 160 }}
													disabled={saving}
												/>
											) : (
												<TextField
													type={type}
													value={(config as any)[key] ?? ""}
													onChange={(e) => onChangeText(key, e.target.value)}
													variant="outlined"
													size="small"
													style={{ width: 220 }}
													disabled={saving}
												/>
											)}
										</FieldCard>
									))}
								</div>

								<SectionTitle>Chu kỳ thanh toán &amp; Email</SectionTitle>
								<div style={{ display: "grid", gap: 14, marginBottom: 16 }}>
									<FieldCard>
										<FieldLabel>
											Ngày kết thúc Kỳ 1
											<InfoTooltip text="Request từ ngày 1 đến ngày này thuộc Kỳ 1. Email Mẫu 2 sẽ gửi vào ngày kế tiếp." />
										</FieldLabel>
										<FieldDesc>
											Mặc định: 15 (tức Kỳ 1 = ngày 1–15, Email Mẫu 2 gửi ngày 16)
										</FieldDesc>
										<NumericFormat
											value={cycleConfig.cycle1EndDay}
											onValueChange={(v) =>
												setCycleConfig((p) => ({ ...p, cycle1EndDay: parseInt(v.value) || 15 }))
											}
											allowNegative={false}
											decimalScale={0}
											customInput={TextField}
											variant="outlined"
											size="small"
											style={{ width: 120 }}
											disabled={saving}
										/>
									</FieldCard>

									<FieldCard>
										<FieldLabel>
											Ngày gửi Email Mẫu 2 cho Kỳ 2
											<InfoTooltip text="Email Mẫu 2 cho các request Kỳ 2 (từ ngày 16 đến cuối tháng) sẽ gửi vào ngày này của tháng sau." />
										</FieldLabel>
										<FieldDesc>Mặc định: 1 (ngày 1 tháng sau)</FieldDesc>
										<NumericFormat
											value={cycleConfig.cycle2EmailDay}
											onValueChange={(v) =>
												setCycleConfig((p) => ({
													...p,
													cycle2EmailDay: parseInt(v.value) || 1,
												}))
											}
											allowNegative={false}
											decimalScale={0}
											customInput={TextField}
											variant="outlined"
											size="small"
											style={{ width: 120 }}
											disabled={saving}
										/>
									</FieldCard>

									<FieldCard>
										<FieldLabel>
											Thanh toán Kỳ 1 (tháng sau)
											<InfoTooltip text="Khoảng ngày thanh toán cho các request Kỳ 1 trong tháng tiếp theo." />
										</FieldLabel>
										<FieldDesc>Mặc định: ngày 1 → 5 tháng sau</FieldDesc>
										<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
											<span>Từ ngày</span>
											<NumericFormat
												value={cycleConfig.cycle1PayStart}
												onValueChange={(v) =>
													setCycleConfig((p) => ({
														...p,
														cycle1PayStart: parseInt(v.value) || 1,
													}))
												}
												allowNegative={false}
												decimalScale={0}
												customInput={TextField}
												variant="outlined"
												size="small"
												style={{ width: 80 }}
												disabled={saving}
											/>
											<span>→</span>
											<NumericFormat
												value={cycleConfig.cycle1PayEnd}
												onValueChange={(v) =>
													setCycleConfig((p) => ({
														...p,
														cycle1PayEnd: parseInt(v.value) || 5,
													}))
												}
												allowNegative={false}
												decimalScale={0}
												customInput={TextField}
												variant="outlined"
												size="small"
												style={{ width: 80 }}
												disabled={saving}
											/>
										</div>
									</FieldCard>

									<FieldCard>
										<FieldLabel>
											Thanh toán Kỳ 2 (tháng sau)
											<InfoTooltip text="Khoảng ngày thanh toán cho các request Kỳ 2 trong tháng tiếp theo." />
										</FieldLabel>
										<FieldDesc>Mặc định: ngày 16 → 20 tháng sau</FieldDesc>
										<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
											<span>Từ ngày</span>
											<NumericFormat
												value={cycleConfig.cycle2PayStart}
												onValueChange={(v) =>
													setCycleConfig((p) => ({
														...p,
														cycle2PayStart: parseInt(v.value) || 16,
													}))
												}
												allowNegative={false}
												decimalScale={0}
												customInput={TextField}
												variant="outlined"
												size="small"
												style={{ width: 80 }}
												disabled={saving}
											/>
											<span>→</span>
											<NumericFormat
												value={cycleConfig.cycle2PayEnd}
												onValueChange={(v) =>
													setCycleConfig((p) => ({
														...p,
														cycle2PayEnd: parseInt(v.value) || 20,
													}))
												}
												allowNegative={false}
												decimalScale={0}
												customInput={TextField}
												variant="outlined"
												size="small"
												style={{ width: 80 }}
												disabled={saving}
											/>
										</div>
									</FieldCard>
								</div>

								<div
									style={{
										background: "#f0f9ff",
										border: "1px solid #bae6fd",
										borderRadius: 8,
										padding: "12px 16px",
										marginBottom: 16,
										fontSize: 13,
										lineHeight: 1.6,
									}}>
									<div style={{ fontWeight: 700, marginBottom: 6, color: "#1e40af" }}>
										📋 Quy tắc hiện tại:
									</div>
									<div>
										• <b>Kỳ 1</b>: Request ngày 1–{cycleConfig.cycle1EndDay} → Email Mẫu 2 ngày{" "}
										{cycleConfig.cycle1EndDay + 1} → Thanh toán ngày {cycleConfig.cycle1PayStart}–
										{cycleConfig.cycle1PayEnd} tháng sau
									</div>
									<div>
										• <b>Kỳ 2</b>: Request ngày {cycleConfig.cycle1EndDay + 1}–cuối tháng → Email
										Mẫu 2 ngày {cycleConfig.cycle2EmailDay} tháng sau → Thanh toán ngày{" "}
										{cycleConfig.cycle2PayStart}–{cycleConfig.cycle2PayEnd} tháng sau
									</div>
								</div>
							</>
						)}

						{activeTab === 1 && (
							<>
								{/* ── Timezone Settings ── */}
								<SectionTitle>Múi giờ &amp; Timezone</SectionTitle>
								<div style={{ display: "grid", gap: 14, marginBottom: 28 }}>
									{FIELDS.filter((f) =>
										["systemTimezone", "bookingValidateByStationTz"].includes(f.key as string)
									).map(({ key, label, description, type, options }) => (
										<FieldCard key={key}>
											<FieldLabel>
												{label}
												<InfoTooltip text={description} />
											</FieldLabel>
											{type === "boolean" ? (
												<FormControlLabel
													control={
														<Switch
															checked={!!(config as any)[key]}
															onChange={() => onChangeBool(key)}
															color="primary"
															disabled={saving}
														/>
													}
													label={
														<span style={{ fontWeight: 500 }}>
															{(config as any)[key] ? "Bật" : "Tắt"}
														</span>
													}
												/>
											) : type === "select" && options ? (
												<Select
													value={(config as any)[key] ?? ""}
													onChange={(e) => onChangeText(key, e.target.value as string)}
													variant="outlined"
													style={{ minWidth: 340 }}
													disabled={saving}>
													{options.map((opt) => (
														<MenuItem
															key={opt.value}
															value={opt.value}>
															{opt.label}
														</MenuItem>
													))}
												</Select>
											) : null}
										</FieldCard>
									))}
								</div>

								{/* ── Customer Success CTA ── */}
								<SectionTitle>Customer Success CTA</SectionTitle>
								<div style={{ display: "grid", gap: 14, marginBottom: 28 }}>
									{FIELDS.filter((f) =>
										["showEsimServiceButton", "showAirportServiceButton"].includes(f.key as string)
									).map(({ key, label, description }) => (
										<FieldCard key={key}>
											<FieldLabel>
												{label}
												<InfoTooltip text={description} />
											</FieldLabel>
											<FormControlLabel
												control={
													<Switch
														checked={!!(config as any)[key]}
														onChange={() => onChangeBool(key)}
														color="primary"
														disabled={saving}
													/>
												}
												label={
													<span style={{ fontWeight: 500 }}>
														{(config as any)[key] ? "Bật" : "Tắt"}
													</span>
												}
											/>
										</FieldCard>
									))}
								</div>

								<SectionTitle>Homepage</SectionTitle>
								<div style={{ display: "grid", gap: 14, marginBottom: 28 }}>
									{FIELDS.filter((f) => ["homepageMaintenanceEnabled"].includes(f.key as string)).map(
										({ key, label, description }) => (
											<FieldCard key={key}>
												<FieldLabel>
													{label}
													<InfoTooltip text={description} />
												</FieldLabel>
												<FormControlLabel
													control={
														<Switch
															checked={!!(config as any)[key]}
															onChange={() => onChangeBool(key)}
															color="primary"
															disabled={saving}
														/>
													}
													label={
														<span style={{ fontWeight: 500 }}>
															{(config as any)[key] ? "Bật" : "Tắt"}
														</span>
													}
												/>
											</FieldCard>
										)
									)}
								</div>
							</>
						)}

						{activeTab === 2 && (
							<>
								{/* ── Station Features ── */}
								<SectionTitle>Station — vận hành quầy</SectionTitle>
								<div style={{ display: "grid", gap: 14, marginBottom: 28 }}>
									{FIELDS.filter((f) =>
										[
											"disableStationNotifications",
											"orderVerificationPinEnabled",
											"verificationExpireJobEnabled",
											"summaryFinishOrderJobEnabled",
										].includes(f.key as string)
									).map(({ key, label, description }) => (
										<FieldCard key={key}>
											<FieldLabel>
												{label}
												<InfoTooltip text={description} />
											</FieldLabel>
											<FormControlLabel
												control={
													<Switch
														checked={!!(config as any)[key]}
														onChange={() => onChangeBool(key)}
														color="primary"
														disabled={saving}
													/>
												}
												label={
													<span style={{ fontWeight: 500 }}>
														{(config as any)[key] ? "Bật" : "Tắt"}
													</span>
												}
											/>
										</FieldCard>
									))}
									{FIELDS.filter((f) =>
										[
											"orderVerificationEffectiveFrom",
											"orderVerificationPinExpiryCalendarDays",
											"orderVerificationPinExpiryMinutes",
											"verificationExpireCron",
											"orderAutoFinishDaysAfterVerify",
										].includes(f.key as string)
									).map(({ key, label, description, type, min, max, step }) => (
										<FieldCard key={key}>
											<FieldLabel>
												{label}
												<InfoTooltip text={description} />
											</FieldLabel>
											{type === "number" ? (
												<NumericFormat
													value={(config as any)[key] ?? ""}
													onValueChange={(values) => {
														const finalValue = values.value;
														if (finalValue === "") {
															const emptyNum =
																key === "orderVerificationPinExpiryCalendarDays"
																	? 3
																	: min ?? 1;
															setConfig((prev) => ({ ...prev, [key]: emptyNum }));
														} else {
															onChangeNumber(key, finalValue);
														}
													}}
													thousandSeparator=","
													decimalSeparator="."
													allowNegative={false}
													decimalScale={0}
													isAllowed={(vals) => {
														const n = Number(vals.floatValue);
														if (vals.floatValue === undefined) return true;
														if (!Number.isFinite(n)) return false;
														if (min !== undefined && n < min) return false;
														if (max !== undefined && n > max) return false;
														return true;
													}}
													customInput={TextField}
													variant="outlined"
													size="small"
													style={{ width: 160 }}
													disabled={saving}
												/>
											) : type === "date" ? (
												<TextField
													type="date"
													value={String((config as any)[key] ?? "")
														.trim()
														.slice(0, 10)}
													onChange={(e) => onChangeText(key, e.target.value)}
													variant="outlined"
													size="small"
													style={{ width: 220 }}
													disabled={saving}
												/>
											) : (
												<TextField
													type="text"
													value={(config as any)[key] ?? ""}
													onChange={(e) => onChangeText(key, e.target.value)}
													variant="outlined"
													size="small"
													style={{ width: 320 }}
													disabled={saving}
												/>
											)}
											{key === "orderVerificationPinExpiryMinutes" &&
												config.orderVerificationPinExpiryCalendarDays !== 0 && (
													<FieldDesc
														style={{
															color: "#b45309",
															marginTop: 10,
															maxWidth: 560,
															lineHeight: 1.45,
														}}>
														<strong>Lưu ý:</strong> khi “PIN hết hạn theo ngày lịch” khác 0,
														hệ thống <strong>không áp dụng</strong> số phút ở ô này — PIN
														hết hạn lúc 00:00 (múi giờ hệ thống) sau N ngày lịch tính từ{" "}
														<em>ngày</em> drop-off. Để test 1 phút: đặt ngày lịch ={" "}
														<strong>0</strong>, Lưu, rồi tạo đơn / phát PIN mới (đơn cũ vẫn
														giữ <code>pinExpiresAt</code> đã tính lúc phát PIN).
													</FieldDesc>
												)}
										</FieldCard>
									))}
								</div>

								{/* ── Hotline ── */}
								<SectionTitle>Hotline</SectionTitle>
								<div style={{ display: "grid", gap: 14, marginBottom: 28 }}>
									<FieldCard>
										<FieldLabel>Số khách gọi trên whalelo.net</FieldLabel>
										<FieldDesc>
											Khách thấy và bấm gọi / WhatsApp số này trên website (trang Contact, FAQ,
											sau khi đặt chỗ). Nhập format nào cũng được — hệ thống tự chuẩn hóa khi
											khách bấm gọi.
										</FieldDesc>
										<TextField
											type="text"
											value={config.landingHotline ?? ""}
											onChange={(e) => onChangeText("landingHotline", e.target.value)}
											variant="outlined"
											size="small"
											placeholder="VD: +84 866 888 431"
											style={{ width: 220 }}
											disabled={saving}
											inputProps={{ maxLength: 40 }}
										/>
									</FieldCard>
									<FieldCard>
										<FieldLabel>Số điền sẵn cho Station</FieldLabel>
										<FieldDesc>
											Station mới tạo chưa có hotline sẽ dùng sẵn 3 số này. Khi Lưu, số mới cũng
											cập nhật cho các Station đang hoạt động (số do đối tác tự nhập không bị ảnh
											hưởng). Không liên quan đến số khách gọi ở trên.
										</FieldDesc>
										<div style={{ display: "grid", gap: 12 }}>
											<div>
												<FieldDesc style={{ marginBottom: 4 }}>
													Hotline chính của Station
												</FieldDesc>
												<TextField
													type="text"
													value={config.defaultMainHotline ?? ""}
													onChange={(e) => onChangeText("defaultMainHotline", e.target.value)}
													variant="outlined"
													size="small"
													placeholder="VD: 0900000000"
													style={{ width: 220 }}
													disabled={saving}
													inputProps={{ maxLength: 40 }}
												/>
											</div>
											<div>
												<FieldDesc style={{ marginBottom: 4 }}>
													Tổng đài chăm sóc khách hàng
												</FieldDesc>
												<TextField
													type="text"
													value={config.defaultGeneralHotline ?? ""}
													onChange={(e) =>
														onChangeText("defaultGeneralHotline", e.target.value)
													}
													variant="outlined"
													size="small"
													placeholder="VD: 0900000001"
													style={{ width: 220 }}
													disabled={saving}
													inputProps={{ maxLength: 40 }}
												/>
											</div>
											<div>
												<FieldDesc style={{ marginBottom: 4 }}>
													WhaleLO hỗ trợ Station (hiện trong email mã PIN gửi khách)
												</FieldDesc>
												<TextField
													type="text"
													value={config.defaultStationSupportHotline ?? ""}
													onChange={(e) =>
														onChangeText("defaultStationSupportHotline", e.target.value)
													}
													variant="outlined"
													size="small"
													placeholder="VD: 0866888431"
													style={{ width: 220 }}
													disabled={saving}
													inputProps={{ maxLength: 40 }}
												/>
											</div>
										</div>
									</FieldCard>
								</div>

								{false && (
									<>
										{/* ── Station Portal broadcast ── */}
										<SectionTitle>Station Portal — Thông báo Broadcast</SectionTitle>
										<FieldDesc style={{ marginBottom: 10, maxWidth: 720 }}>
											Tiêu đề và nội dung HTML không chỉnh tại đây. Nếu bật mà chưa có nội dung
											trong cấu hình, hệ thống lưu bản mặc định ngắn; bản đã lưu trước đó vẫn giữ
											nguyên.
										</FieldDesc>
										<div style={{ display: "grid", gap: 14, marginBottom: 28 }}>
											<FieldCard>
												<FieldLabel>
													Bật thông báo cho toàn bộ Station Portal
													<InfoTooltip text="Khi bật, station/partner đang đăng nhập hoặc mở portal sẽ thấy nội dung trong khung thời gian đã đặt. Chế độ Popup: tự mở hộp thoại một lần mỗi phiên trình duyệt (có thể đóng). Chế độ Nút nổi: luôn có nút để đọc thông báo." />
												</FieldLabel>
												<FormControlLabel
													control={
														<Switch
															checked={!!config.stationPortalBroadcastEnabled}
															onChange={() =>
																setConfig((prev) => ({
																	...prev,
																	stationPortalBroadcastEnabled:
																		!prev.stationPortalBroadcastEnabled,
																}))
															}
															color="primary"
															disabled={saving}
														/>
													}
													label={
														<span style={{ fontWeight: 500 }}>
															{config.stationPortalBroadcastEnabled
																? "Đang phát sóng"
																: "Tắt"}
														</span>
													}
												/>
											</FieldCard>
											<FieldCard>
												<FieldLabel>Thời điểm bắt đầu (tuỳ chọn)</FieldLabel>
												<FieldDesc>
													Để trống = có hiệu lực ngay khi đã bật và trong khoảng tới thời điểm
													kết thúc.
												</FieldDesc>
												<TextField
													type="datetime-local"
													variant="outlined"
													size="small"
													value={toDatetimeLocalValue(config.stationPortalBroadcastStartsAt)}
													onChange={(e) =>
														setConfig((prev) => ({
															...prev,
															stationPortalBroadcastStartsAt: fromDatetimeLocalValue(
																e.target.value
															),
														}))
													}
													disabled={saving}
													InputLabelProps={{ shrink: true }}
												/>
											</FieldCard>
											<FieldCard>
												<FieldLabel>Thời điểm kết thúc (bắt buộc khi bật)</FieldLabel>
												<FieldDesc>Sau thời điểm này broadcast không còn hiển thị.</FieldDesc>
												<TextField
													type="datetime-local"
													variant="outlined"
													size="small"
													value={toDatetimeLocalValue(config.stationPortalBroadcastEndsAt)}
													onChange={(e) =>
														setConfig((prev) => ({
															...prev,
															stationPortalBroadcastEndsAt: fromDatetimeLocalValue(
																e.target.value
															),
														}))
													}
													disabled={saving}
													InputLabelProps={{ shrink: true }}
												/>
											</FieldCard>
											<FieldCard>
												<FieldLabel>Cách hiển thị</FieldLabel>
												<FieldDesc>
													<strong>Popup:</strong> tự mở một lần mỗi phiên.{" "}
													<strong>Nút nổi:</strong> nút góc màn hình, bấm để đọc — luôn hiện
													trong suốt thời gian hiệu lực.
												</FieldDesc>
												<Select
													value={config.stationPortalBroadcastDisplayMode}
													onChange={(e) =>
														setConfig((prev) => ({
															...prev,
															stationPortalBroadcastDisplayMode: e.target.value as
																| "popup"
																| "floating_button",
														}))
													}
													variant="outlined"
													style={{ minWidth: 280 }}
													disabled={saving}>
													<MenuItem value="popup">Popup (tự mở)</MenuItem>
													<MenuItem value="floating_button">Nút thông báo nổi</MenuItem>
												</Select>
											</FieldCard>
											<FieldCard>
												<FieldLabel>
													Chỉ hiển thị cho trạm tạo trong hoặc trước ngày (tuỳ chọn)
													<InfoTooltip text="Để trống = mọi trạm đều có thể thấy popup (trong khung giờ broadcast). Nhập YYYY-MM-DD ví dụ 2026-04-25: chỉ partner có ngày tạo (Partner.createdAt, theo múi giờ hệ thống) ≤ ngày này mới thấy; trạm tạo từ 26/04/2026 trở đi (sau ngày cắt) sẽ không thấy." />
												</FieldLabel>
												<FieldDesc>
													Định dạng <code style={{ fontSize: 12 }}>YYYY-MM-DD</code>. Trống =
													không lọc theo ngày tạo trạm.
												</FieldDesc>
												<TextField
													type="date"
													variant="outlined"
													size="small"
													value={
														String(
															config.stationPortalBroadcastPartnerCreatedOnOrBefore ?? ""
														)
															.trim()
															.slice(0, 10) || ""
													}
													onChange={(e) =>
														setConfig((prev) => ({
															...prev,
															stationPortalBroadcastPartnerCreatedOnOrBefore:
																e.target.value || "",
														}))
													}
													disabled={saving}
													InputLabelProps={{ shrink: true }}
												/>
											</FieldCard>
											<FieldCard>
												<FieldLabel>
													Miễn tick legal agreement cho trạm tạo từ ngày (tuỳ chọn)
												</FieldLabel>
												<FieldDesc>
													Định dạng <code style={{ fontSize: 12 }}>YYYY-MM-DD</code>. Ví dụ{" "}
													<code style={{ fontSize: 12 }}>2026-04-27</code>: trạm có
													Partner.createdAt trong ngày này hoặc sau đó sẽ không bị bắt accept
													lại legal agreement trên Station Portal. Trống = vẫn áp gate legal
													agreement cho mọi trạm.
												</FieldDesc>
												<TextField
													type="date"
													variant="outlined"
													size="small"
													value={
														String(
															config.stationPortalLegalAgreementExemptPartnerCreatedOnOrAfter ??
																""
														)
															.trim()
															.slice(0, 10) || ""
													}
													onChange={(e) =>
														setConfig((prev) => ({
															...prev,
															stationPortalLegalAgreementExemptPartnerCreatedOnOrAfter:
																e.target.value || "",
														}))
													}
													disabled={saving}
													InputLabelProps={{ shrink: true }}
												/>
											</FieldCard>
											<FieldCard>
												<FieldLabel>
													Bắt buộc Welcome Aboard onboarding cho trạm tạo từ ngày (tuỳ chọn)
												</FieldLabel>
												<FieldDesc>
													Định dạng <code style={{ fontSize: 12 }}>YYYY-MM-DD</code>. Ví dụ{" "}
													<code style={{ fontSize: 12 }}>2026-05-05</code>: chỉ station có
													Partner.createdAt từ ngày này trở đi mới thấy form Welcome Aboard
													khi vào Station Portal. Trống = không hiển thị Welcome Aboard với
													bất kỳ trạm nào.
												</FieldDesc>
												<TextField
													type="date"
													variant="outlined"
													size="small"
													value={
														String(config.stationPortalOnboardingRequiredFromDate ?? "")
															.trim()
															.slice(0, 10) || ""
													}
													onChange={(e) =>
														setConfig((prev) => ({
															...prev,
															stationPortalOnboardingRequiredFromDate:
																e.target.value || "",
														}))
													}
													disabled={saving}
													InputLabelProps={{ shrink: true }}
												/>
											</FieldCard>
										</div>
									</>
								)}
								<FieldCard style={{ marginBottom: 28 }}>
									<FieldLabel>Station Portal Broadcast</FieldLabel>
									<FieldDesc>
										Phần broadcast và legal agreement exemption đã chuyển sang trang Notifications.
									</FieldDesc>
									<a
										href="/notifications"
										style={{ color: "#2563eb", fontWeight: 600, textDecoration: "none" }}>
										Mở /notifications →
									</a>
								</FieldCard>
								{/* ── Run Finish Job Now ── */}
								<div style={{ marginBottom: 28 }}>
									<FieldCard>
										<FieldLabel>Chạy job ngay bây giờ</FieldLabel>
										<FieldDesc>
											Trigger thủ công job Confirmed → Finished. Dùng <strong>Preview</strong>{" "}
											trước để xem đơn nào đủ điều kiện.
										</FieldDesc>
										<div style={{ display: "flex", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
											<button
												onClick={onPreviewFinishJob}
												disabled={previewingFinishJob || runningFinishJob}
												style={{
													padding: "8px 18px",
													borderRadius: 8,
													border: "1.5px solid #2563eb",
													background: "#fff",
													color: "#2563eb",
													fontWeight: 600,
													fontSize: 14,
													cursor: previewingFinishJob ? "not-allowed" : "pointer",
												}}>
												{previewingFinishJob ? "Đang kiểm tra..." : "🔍 Preview (không update)"}
											</button>
											<PermissionGate permission="settings.manage">
												<button
													onClick={onRunFinishJob}
													disabled={runningFinishJob || previewingFinishJob}
													style={{
														padding: "8px 20px",
														borderRadius: 8,
														border: "none",
														background: runningFinishJob ? "#9ca3af" : "#16a34a",
														color: "#fff",
														fontWeight: 600,
														fontSize: 14,
														cursor: runningFinishJob ? "not-allowed" : "pointer",
													}}>
													{runningFinishJob ? "Đang chạy..." : "▶ Chạy — Cập nhật ngay"}
												</button>
											</PermissionGate>
										</div>
										{finishJobPreview !== null && (
											<div
												style={{
													marginTop: 14,
													padding: "12px 16px",
													background: finishJobPreview.total === 0 ? "#fef9c3" : "#f0fdf4",
													borderRadius: 8,
													border: `1px solid ${
														finishJobPreview.total === 0 ? "#fbbf24" : "#86efac"
													}`,
												}}>
												{finishJobPreview.total === 0 ? (
													<span style={{ color: "#92400e", fontWeight: 500 }}>
														⚠️ Không có đơn nào đủ điều kiện hiện tại (timeOut +{" "}
														{config.orderAutoFinishDaysAfterVerify} ngày ≤ hôm nay).
													</span>
												) : (
													<>
														<div
															style={{
																fontWeight: 600,
																color: "#15803d",
																marginBottom: 8,
															}}>
															✅ {finishJobPreview.total} đơn đủ điều kiện sẽ chuyển
															Finished:
														</div>
														<table
															style={{
																width: "100%",
																borderCollapse: "collapse",
																fontSize: 13,
															}}>
															<thead>
																<tr style={{ borderBottom: "1px solid #bbf7d0" }}>
																	<th
																		style={{
																			textAlign: "left",
																			padding: "4px 8px",
																		}}>
																		ID
																	</th>
																	<th
																		style={{
																			textAlign: "left",
																			padding: "4px 8px",
																		}}>
																		timeOut
																	</th>
																	<th
																		style={{
																			textAlign: "left",
																			padding: "4px 8px",
																		}}>
																		verifiedAt
																	</th>
																</tr>
															</thead>
															<tbody>
																{finishJobPreview.orders.map((o) => (
																	<tr
																		key={o.id}
																		style={{ borderBottom: "1px solid #dcfce7" }}>
																		<td style={{ padding: "4px 8px" }}>#{o.id}</td>
																		<td style={{ padding: "4px 8px" }}>
																			{o.timeOut
																				? new Date(
																						o.timeOut
																				  ).toLocaleDateString("vi-VN")
																				: "—"}
																		</td>
																		<td style={{ padding: "4px 8px" }}>
																			{o.verifiedAt
																				? new Date(
																						o.verifiedAt
																				  ).toLocaleDateString("vi-VN")
																				: "—"}
																		</td>
																	</tr>
																))}
															</tbody>
														</table>
													</>
												)}
											</div>
										)}
									</FieldCard>
								</div>
							</>
						)}

						<StickySaveRow>
							<PermissionGate permission="settings.manage">
								<SaveButton
									onClick={onSave}
									disabled={loading || saving}>
									{saving ? (
										<>
											<CircularProgress
												size={16}
												style={{ color: "#fff" }}
											/>{" "}
											Đang lưu...
										</>
									) : (
										"💾 Lưu cấu hình"
									)}
								</SaveButton>
							</PermissionGate>
						</StickySaveRow>
					</>
				)}
			</PageCard>
			<Dialog
				open={hotlineConfirm.open}
				onClose={() => !saving && setHotlineConfirm({ open: false, affectedCount: 0, inputValue: "" })}
				maxWidth="sm"
				fullWidth>
				<DialogTitle>⚠️ Ghi đè hotline trên station hiện có</DialogTitle>
				<DialogContent>
					<p style={{ marginBottom: 12 }}>
						Sẽ ghi đè hotline trên <strong>{hotlineConfirm.affectedCount}</strong> station đang active. Hành
						động này KHÔNG thể undo (audit log có lưu giá trị cũ để restore thủ công).
					</p>
					<p style={{ marginBottom: 12, fontSize: 13, color: "#6b7280" }}>
						Slot rỗng sẽ KHÔNG bị đụng. Chỉ slot có value mới được ghi đè.
					</p>
					<p style={{ marginBottom: 8, fontWeight: 600 }}>
						Gõ <code>OVERWRITE</code> để xác nhận:
					</p>
					<TextField
						value={hotlineConfirm.inputValue}
						onChange={(e) => setHotlineConfirm((s) => ({ ...s, inputValue: e.target.value }))}
						variant="outlined"
						size="small"
						fullWidth
						autoFocus
						disabled={saving}
						placeholder="OVERWRITE"
					/>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => setHotlineConfirm({ open: false, affectedCount: 0, inputValue: "" })}
						disabled={saving}>
						Hủy
					</Button>
					<Button
						onClick={doSave}
						disabled={hotlineConfirm.inputValue !== "OVERWRITE" || saving}
						variant="contained"
						color="primary">
						{saving ? "Đang lưu..." : "Xác nhận ghi đè"}
					</Button>
				</DialogActions>
			</Dialog>
		</MyBookingWrapper>
	);
}
